<template>
    <div>
        <div class="content-header row">
            <div class="content-header-left col-md-7 col-12 mb-2">
                <div class="row breadcrumbs-top">
                    <div class="col-12">
                        <h2 class="content-header-title float-left mb-0">{{trans('posTransaction.bill_posTransaction')}}
                        </h2>
                        <div class="breadcrumb-wrapper col-12">
                            <ol class="breadcrumb">
                                <li class="breadcrumb-item">
                                    <router-link to="/home">
                                        {{ trans('general.home') }}
                                    </router-link>
                                </li>
                                <li class="breadcrumb-item">
                                     <router-link to="/payment">
                                        {{ trans('payment.bill_payment') }}
                                    </router-link>
                                </li>
                                <li class="breadcrumb-item active">
                                    POS Transactions
                                </li>
                            </ol>
                        </div>
                    </div>
                </div>
            </div>
            <div class="content-header-right text-md-right col-md-5 col-12 d-md-block d-none">
                <div class="form-group breadcrum-right">
                    <button class="btn btn-primary btn-sm pull-right" v-if="!showFilterPanel" @click="showFilterPanel = !showFilterPanel"><i class="feather icon-filter"></i> {{trans('general.filter')}}</button>
                    
                </div>
            </div>

        </div>

    <div class="content-body">
        <section id="basic-datatable">
            <div class="row">
                <div class="col-12">

                    <transition name="fade">
                        <div class="card border-bottom" v-if="showFilterPanel">
                            <div class="card-header">
                                <h4 class="card-title float-left mb-0">{{trans('general.filter')}}</h4>
                                <export-excel
                                    class   = "btn btn-success btn-sm mr-1 mb-1 waves-effect waves-light pull-right"
                                    :data   = "posTransactions.data"
                                    :fields = "json_fields"
                                    worksheet = "Sokoto State Inland Revenue Service"
                                    name    = "posTransaction.xls">
                                 
                                    <i class="feather icon-file-text"></i> Export to Excel
                                 
                                </export-excel>
                            </div>
                            <div class="card-content">
                                <div class="card-body">
                                <div class="row">
                                    <div class="col-6">
                                        <div class="form-group">
                                            <label for="">{{trans('general.keyword')}}</label>
                                            <input class="form-control" name="keyword" v-model="filterPosTransactionForm.keyword">
                                        </div>
                                    </div>
                                    <div class="col-12">
                                        <div class="form-group">
                                            <date-range-picker :start-date.sync="filterPosTransactionForm.start_date" :end-date.sync="filterPosTransactionForm.end_date" :label="trans('general.date_between')"></date-range-picker>
                                        </div>
                                    </div>
                                </div>
                                <button class="btn btn-danger waves-effect waves-light pull-right mr-1 mb-1" v-if="showFilterPanel" @click="showFilterPanel = !showFilterPanel">{{trans('general.cancel')}}</button>
                            </div>
                            </div>
                        </div>
                    </transition>
                    
                    <div class="card">
                        <div class="card-header">
                            <h4 v-if="posTransactions.total" class="card-title">
                                <sort-by :order-by-options="orderByOptions" :sort-by="filterPosTransactionForm.sort_by" :order="filterPosTransactionForm.order" @updateSortBy="value => {filterPosTransactionForm.sort_by = value}"  @updateOrder="value => {filterPosTransactionForm.order = value}"></sort-by>
                            </h4>
                        </div>
                        <div class="card-content">
                            <div class="card-body">
                                <div class="table-responsive" v-if="posTransactions.total">
                                <table class="table">
                                    <thead>
                                        <tr>
                                            <th>{{trans('general.serial_number')}}</th>
                                            <th>{{trans('general.date')}}</th>
                                            <th>MDA</th>
                                            <th>Business ID</th>
                                            <th>Terminal Serial</th>
                                            <th>Type</th>
                                            <th>{{trans('payment.amount')}}</th>
                                            <th>{{trans('payment.reference')}}</th>
                                            <th>{{trans('general.status')}}</th>
                                            <th class="table-option">{{trans('general.action')}}</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="(posTransaction, index) in posTransactions.data">
                                            <td v-text="index+1"></td>
                                            <td>{{posTransaction.transaction_time | momentDateTime}}</td>
                                            <td v-text="posTransaction.mda && posTransaction.mda.name ? posTransaction.mda.name : 'N/A'"></td>
                                            <td v-text="posTransaction.business_id"></td>
                                            <td v-text="posTransaction.terminal_serial"></td>
                                            <td v-text="posTransaction.transaction_type"></td>
                                            <td>{{ posTransaction.amount | formatMoney }}</td>
                                            <td v-text="posTransaction.transaction_reference"></td>
                                            <td>
                                                <span class="badge" :class="{
                                                    'badge-success': posTransaction.transaction_status === 'SUCCESSFUL',
                                                    'badge-danger': posTransaction.transaction_status === 'FAILED',
                                                    'badge-warning': posTransaction.transaction_status === 'PENDING'
                                                }">
                                                    {{ posTransaction.transaction_status }}
                                                </span>
                                            </td>
                                            <td class="table-option">
                                                <div class="btn-group">
                                                    <a :href="`/payment/pos-transaction/${posTransaction.transaction_reference}/print`" 
                                                    target="_blank" 
                                                    class="btn btn-primary btn-sm" 
                                                    v-tooltip="trans('payment.print_payment')">
                                                        <i class="feather icon-printer"></i> Print
                                                    </a>
                                                </div>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                            <module-info v-if="!posTransactions.total" module="payment" title="module_info_title" description="module_info_description" icon="check-circle">
                                <div slot="btn">
                                    <button class="btn btn-primary btn-md" @click="$router.push('/payment/create')"><i class="feather icon-plus"></i> {{trans('general.add_new')}}</button>
                                </div>
                            </module-info>
                            <pagination-record :page-length.sync="filterPosTransactionForm.page_length" :records="posTransactions" @updateRecords="getPosTransactions"></pagination-record>
                             
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        
   </div>
    </div>
</template>

<script>
    import sortBy from '../../components/sort-by'
    import dateRangePicker from '../../components/date-range-picker'

    export default {
        components : { sortBy,dateRangePicker },
        data() {
            return {
                userRole: '',
                posTransactions: {
                    total: 0,
                    data: []
                },
                
                filterPosTransactionForm: {
                    keyword: '',
                    start_date: '',
                    end_date: '',
                    sort_by : 'created_at',
                    order: 'desc',
                    page_length: helper.getConfig('page_length')
                },
                orderByOptions: [
                    {
                        value: 'tax_id',
                        translation: i18n.payment.tax_id
                    },
                    {
                        value: 'payer',
                        translation: i18n.payment.payer
                    },
                    {
                        value: 'reference',
                        translation: i18n.payment.reference
                    }
                ],
                showFilterPanel: false,
                applicationStatus: false,
                json_fields: {
                    'Tax ID': 'tax_id',
                    'Payer': 'payer',
                    'Address': 'address',
                    'Amount': 'amount',
                    'Transaction Reference': 'reference'
                    
                },
                json_meta: [
                    [
                        {
                            'key': 'charset',
                            'value': 'utf-8'
                        }
                    ]
                ],
            };
        },
        mounted(){
            if(!helper.hasPermission('list-pos-transaction')){
                helper.notAccessibleMsg();
                this.$router.push('/home');
            }

            if(!helper.featureAvailable('payment')){
                helper.featureNotAvailableMsg();
                this.$router.push('/home');
            }

            this.getPosTransactions();
            this.userRole = this.getRole()[0];
            
        },
        beforeDestroy() {
            clearInterval(this.timer)
        },
        methods: {
            getRole(role){
              return helper.getRole(role);
            },
            hasPermission(permission){
                return helper.hasPermission(permission);
            },
            hasRole(role){
                return helper.hasRole(role);
            },
            getPosTransactions(page){
                if (typeof page !== 'number') {
                    page = 1;
                }
                let url = helper.getFilterURL(this.filterPosTransactionForm);
                axios.get('/api/pos-transaction?page=' + page + url)
                    .then(response => response.data)
                    .then(response => this.posTransactions = response)
                    .catch(error => {
                        helper.showDataErrorMsg(error);
                    });
            },
            
            getStatus(posTransaction){
                return posTransaction.transaction_status == 'SUCCESSFUL' ? ('<span class="badge badge-success">'+i18n.payment.paid+'</span>') : ('<span class="badge badge-danger">'+i18n.payment.not_paid+'</span>');
            }
        },
        filters: {
          momentDateTime(date) {
            return helper.formatDateTime(date);
          },
          formatMoney(value){
            return helper.formatMoney(value);
          }
        },
        watch: {
            filterPosTransactionForm: {
                handler(val){
                    setTimeout(() => {
                        this.getPosTransactions();
                    }, 500)
                },
                deep: true
            }
        }
    }
</script>